<template>
   <el-container  style="display: block;background-color: #ffffff;" :style="{'width':screenWidth+'px','height':screenHeight+'px'}">
    <el-row :span="2" style="margin-top: 30px;margin-left: 10%;">

        <el-row :span="2" style="margin-top: 30px;">
            名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            视频地址:<el-input v-model="url" style="width: 150px;" placeholder="请输入视频地址"></el-input>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            标签:<el-input v-model="ci" style="width: 150px;" placeholder="请输入标签"></el-input>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
        </el-row>
    </el-row>

     <div :style="{'width':screenWidth,'height':screenHeight}" style="display: flex;flex-wrap: wrap;overflow-y: scroll;background-color: #fff;">
      <el-row   style="margin-top: 30px;margin-left: 10%;">
        <template>
          <el-table
        	:data="list"
          height="800"
        	border
          :style="{'height':screenHeight*0.95+'px'}"
        	style="width: 95%;margin-left: 0;text-align: center;background-color: #ffffff;">

          <el-table-column

            width="300"
            label="id"
             >
             <template slot-scope="scope">
                 <div>{{scope.row.i_id}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="300"
            label="名称"
             >
             <template slot-scope="scope">
                 <div  @click="dischange(scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="400"
            label="视频地址"
             >
             <template slot-scope="scope">
                 <div  @click="dischange(scope.row.url,scope.row.id,2)">{{scope.row.url}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="400"
            label="标签"
             >
             <template slot-scope="scope">
                 <div  @click="dischange(scope.row.ci,scope.row.id,3)">{{scope.row.ci}}</div>
             </template>
          </el-table-column>

          <el-table-column

            width="400"
            label="操作"
             >
             <template slot-scope="scope">
               <el-row>
                 <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id)">删除</el-col>

               </el-row>
             </template>
          </el-table-column>
          </el-table>
        </template>

      </el-row>





     </div>


    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
   <el-dialog
     title="修改"
     :visible.sync="disDialogVisible"
     width="30%"
     center>
     <input type="text" class="searchT" v-model="names"/>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="disDialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="dodisChange()">确 定</el-button>
     </span>
   </el-dialog>
   <el-dialog
     title="提示"
     :visible.sync="dialogVisible"
     width="30%"
     >
     <span>确认删除？</span>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="dialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="doDell()">确 定</el-button>
     </span>
   </el-dialog>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        disDialogVisible:false,
        changeId:0,
        t:0,
        names:'',
        dialogVisible:false,
        delId:0,
        list:[],
        id:this.$route.query.id,
        name:'无',
        url:'',
        ci:'',
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-20)/20,
        vheight : window.innerHeight/200,

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()




    },

	methods:{

    del(id){
      this.dialogVisible = true
      this.delId = id
    },
    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_video_del'
      })
      .then(res=>{
        this.msg('删除成功','success');
        this.dialogVisible = false
        this.loadList()
      })
      .catch(err=>{

      });

    },

    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_video_Changes'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.url == ''){
        this.msg('请填写视频地址','error')
        return false
      }
      if(this.ci == ''){
        this.msg('请填写标签','error')
        return false
      }


      axiosInstance({
      	method:'post',
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_video_add',
      	params:{
      		name:this.name,
          i_id:this.id,
      		url:this.url,
          ci:this.ci

      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:this.id,


      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/shopGuanli_video_list'
      })
      .then(res=>{
        this.list = res.data.list;

        // console.log(this.list)


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;

}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  /* .el-scrollbar__wrap{
    background-color: black;
  } */
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shopvideos.vue